export const INVOICE_PRINT_ROOT = 'xsib-invoice-print'

export const INVOICE_PRINT_CSS = `
  .${INVOICE_PRINT_ROOT} { display: none; }
  @media print {
    @page { size: A4; margin: 14mm; }
    html, body { margin: 0 !important; padding: 0 !important; background: #fff !important; }
    body > *:not(.${INVOICE_PRINT_ROOT}) { display: none !important; }
    .${INVOICE_PRINT_ROOT} { display: block; }
  }
`

const LOGO_WAIT_MS = 3000

export async function invoiceImagesSettled(): Promise<void> {
  const images = Array.from(document.querySelectorAll<HTMLImageElement>(`.${INVOICE_PRINT_ROOT} img`))
  const decodes = images.map((image) => image.decode().catch(() => undefined))
  const timeout = new Promise<void>((resolve) => setTimeout(resolve, LOGO_WAIT_MS))
  await Promise.race([Promise.all(decodes).then(() => undefined), timeout])
}
